import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/core';
import { useRoute } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';
import { Text, TextInput, TouchableOpacity, View } from 'react-native';

import GradientButton from '../../components/GradientButton';
import HeaderDefault from '../../components/HeaderDefault';
import { formatCoin } from '../../utils/formatNumber';

import { styles } from './styles';

const WithdrawGPX = () => {
  const navigation = useNavigation();
  const route = useRoute();

  const [userName, setUserName] = useState('');
  const [value, setValue] = useState('150');
  const [fee, setFee] = useState(6);


  useEffect(() => {
    async function getUserName() {
      const userName = await AsyncStorage.getItem("nameuser");
      setUserName(userName);
    }
    getUserName();
  }, []);

  const { bankAccountId } = route.params;

  const checkValue = () => {
    if(parseInt(value+'') < 150) {
      setValue('150');
    }
  }

  return (
    <View style={{ flex: 1 }}>
      <HeaderDefault title="Sacar GPX" />

      <View style={styles.container}>
        <View>
          <View style={styles.receiver}>
            <Text style={styles.textBold}>Recebedor</Text>
            <Text>{userName}</Text>
          </View>

          <Text>
            Digite a quantidade desejada
          </Text>
          <View style={styles.inputContainer}>
            <Text style={styles.textBold}>GPX</Text>
            <TextInput style={styles.input} value={value} onChangeText={setValue} keyboardType="number-pad" defaultValue="0.1" onBlur={() => {checkValue()}} />
            <TouchableOpacity>
              <Text style={styles.textBold}>{/*Máx*/}</Text>
            </TouchableOpacity>
          </View>

          <View style={{alignItems: 'center'}}>
            <Text>Mínimo de R$ 150,00</Text>
          </View>

          <View style={styles.summary}>
            <View style={styles.spaceBetween}>
              <Text style={styles.textBold}>Valor do saque</Text>
              <Text>{formatCoin(parseFloat(value) || 0)} GPX</Text>
            </View>
            <View style={styles.spaceBetween}>
              <Text style={styles.textBold}>Taxa GPX</Text>
              <Text>{formatCoin(fee)} GPX</Text>
            </View>
            <View style={styles.spaceBetween}>
              <Text style={styles.textBold}>Valor a receber</Text>
              <Text>{formatCoin((parseFloat(value) || 0) - fee)} GPX</Text>
            </View>
          </View>
        </View>

        <GradientButton onPress={() => navigation.navigate({ name: 'WithdrawGPXPassword', params: { value, bankAccountId } })}>CONFIRMAR</GradientButton>
      </View>
    </View>
  );
}

export default WithdrawGPX;